<!-- service pdf start -->
<div #printData id="print-data"
    class="container-fluid main-bg d-flex flex-column align-items-center justify-content-start" contenteditable="true"
    *ngIf="tableofItems && !processing && fromService">

    <div class="container p-0 max-w-h-custom s-bg-img-1" style="position: relative;">
        <div class="p-pdf-bottom">
            <div class="px-6rem">
                <div class="d-flex flex-column gap-4">
                    <app-drag>
                        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                    </app-drag>
                    <app-drag>
                        <img *ngIf="tableofItems.length == 1" class="pdf-page-logo-left-mr"
                            src="{{fileUrl + tableofItems[0].heading_icon}}" alt="loading">
                    </app-drag>
                </div>

                <div class="d-flex justify-content-center">
                    <div class="s-flex">
                        <div style="display: flex; align-items:center; flex-direction: column; text-align: center; padding:30px"
                            *ngIf="tableofItems[0].heading != page_heading">
                            <app-drag>
                                <h1 style="font-size:30px; color: #2B2A66; font-weight: 800 ; text-wrap: nowrap;">
                                    {{currentTypeFilter+" for print"
                                    | translator}}</h1>
                            </app-drag>
                            <app-drag>
                                <h1 style="font-size:30px; color: #2B2A66; font-weight: 800 ; text-wrap: nowrap;">
                                    {{page_heading}}</h1>
                            </app-drag>
                            <hr *ngIf="tableofItems[0].heading != page_subheading" class="hr" style="margin:10px">
                            <app-drag>
                                <h3 style="font-size:20px; color: #2B2A66; font-weight: bold; text-wrap: nowrap;">
                                    {{page_subheading}}</h3>
                            </app-drag>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pos-abs-pdf-footer">
            <div class="s-footer">
                <div class="c-f-img-1">
                    <app-drag>
                        <img class="c-f-img-1-pic" src="../../../../assets/icones-2025/Vector.png" alt="loading">
                    </app-drag>
                </div>

                <div class="c-f-img-2">
                    <app-drag>
                        <!-- <img class="c-f-img-2-pic" src="../../../../assets/icones-2025/Group-2.png" alt="loading"> -->
                        <img class="c-f-img-2-pic" src="../../assets/icones-2025/Layer_gradiant.png" alt="loading">
                    </app-drag>
                </div>
                <div class="s-footer-flex" contenteditable="false">
                    <div class="s-footer-txt-2" style="text-align: center;">
                        <app-drag contentClass="d-flex flex-column">
                            <div contenteditable="true" class="clr-white">الإجمالي</div>
                            <div contenteditable="true" class="clr-white">{{data.length}}</div>
                        </app-drag>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h banner my-2 print-area" style="page-break-before: always;">
        <div class="bg-banner-2 bg-white d-flex justify-content-center align-items-center">
            <app-drag>
                <img class="vector vector-pdf-view 22" style="width: 160px; height: auto;" src="../../../../assets/new-logo/icon-01.svg"
                    alt="loading">
            </app-drag>
        </div>
    </div>

    <div class="container max-w-h banner my-2 print-area d-flex align-items-center justify-content-center"
        style="page-break-before: always;" contenteditable="false">
        <app-drag>
            <div class="d-flex flex-column p-adjustment">
                <div class="d-flex">
                    <div class="d-flex align-items-center m-left">
                        <img class="less" src="../../../../assets/pngegg.png" alt="loading">
                        <div class="circle-2"></div>
                        <div class="circle-2"></div>
                        <div class="circle-2"></div>
                    </div>
                    <div class="pdf-heading" contenteditable="true">حقوق الملكية الفكرية ©</div>
                </div>
                <div class="pdf-text" contenteditable="true">حقوق الملكية الفكرية محفوظة للمركز السعودي للتنافسية والأعمال، ويحظر الاعتداء عليها بأي شكل من الأشكال المخالفة لنظام حماية حقوق المؤلف وحماية الملكية الفكرية.</div>

            </div>
        </app-drag>
    </div>

    <div id="index-page" class="container bg-white-pdf max-w-h-custom"
        style="page-break-before: always;margin: 0; padding: 0;">
        <div class="only-x-6rem">
            <div *ngIf="tableofItems" style="padding: 20px;">

                <h1 style="text-align: center; width: 100%;">{{"Table of contents" | translator}}</h1>

                <!-- index page table -->
                <table style="width: 100%; margin: 10px 0px;">
                    <tr>
                        <th style="width:10%;">{{"aljaha" | translator}}</th>
                        <th style="width:20%;">{{"almastue alraise" | translator}}</th>
                        <th style="width:40%;">{{"alkhidmat" | translator}}</th>

                        <th style="width:30%">{{"almastuie alfaraie" | translator}}</th>
                        <th style="width:30%">{{"Start from" | translator}}</th>
                    </tr>
                </table>

                <div *ngFor="let heading of tableofItems; let headingIndex = index" style="margin-bottom: 10px;">

                    <div style="display: flex; align-items: center;">
                        <span style="margin-right: 10px;">
                            <span class="pdf-text">{{headingIndex+1}}. </span>
                            <img src="{{GlobalConstants.staticFilesURL + heading?.heading_icon}}"
                                *ngIf="checkisImg(heading?.heading_icon); else elseBlock"
                                style="width: 20px; height: auto; margin-left:10px;" class="img-fluid" alt="">
                            <ng-template #elseBlock>
                                <i class="pi pi-{{heading.heading_icon}} img-fluid"></i>
                            </ng-template>
                        </span>
                        <p class="mb-0" style="font-weight: bold;line-height: 2; color: #27306F;"
                            [innerHTML]="(heading.heading ?? '') | safeHTML">
                        </p>
                    </div>

                    <div *ngFor="let subheading of heading.subheadings; let subheadingIndex = index"
                        style="margin-bottom: 5px;">
                        <!-- margin-left: 20px;  -->
                        <div style="display: flex; align-items: center;page-break-after: avoid;">
                            <span>
                                <!-- style="margin-right: 30px;"upper span style -->
                                <span class="pdf-text">{{headingIndex+1}}.{{subheadingIndex+1}} </span>
                                <img src="{{GlobalConstants.staticFilesURL + subheading?.subheading_icon}}"
                                    *ngIf="checkisImg(subheading?.subheading_icon); else elseBlock"
                                    style="width: 20px; height: auto;  margin-left:10px;" class="img-fluid" alt="">
                                <ng-template #elseBlock>
                                    <i class="pi pi-{{subheading.subheading_icon}} img-fluid"></i>
                                </ng-template>
                            </span>
                            <p class="mb-0" style="font-weight: bold;line-height: 2; color: #27306F;"
                                [innerHTML]="(subheading.subheading ?? '') | safeHTML">
                            </p>
                        </div>
                        <!-- style="width: calc(100% - 60px); margin-right: 60px;" -->
                        <table style="page-break-before: avoid;">
                            <tr *ngFor="let item of subheading.items; let itemIndex = index">
                                <td>#</td>
                                <td style="width:10%; margin-left: 5px;">
                                    {{headingIndex+1}}.{{subheadingIndex+1}}.{{itemIndex+1}}</td>
                                <td style="width:60%">{{ item.title }}</td>
                                <td style="width:30%">
                                    <table>
                                        <tr>
                                            <td style="width: 10%; padding-left: 5px;">
                                                <img src="{{GlobalConstants.staticFilesURL + item?.subsubheading_icon}}"
                                                    *ngIf="checkisImg(item?.subsubheading_icon); else elseBlock"
                                                    style="width: 15px; height: auto;  margin-left:10px;"
                                                    class="img-fluid" alt="">
                                                <ng-template #elseBlock>
                                                    <i class="pi pi-{{item.subsubheading_icon}} img-fluid"
                                                        style="font-size: smaller;"></i>
                                                </ng-template>
                                            </td>
                                            <td style="width: 90%; font-size: small;"
                                                [innerHTML]="(item.subsubheading ?? '') | safeHTML"></td>
                                        </tr>
                                    </table>
                                </td>
                                <td>{{indexData[getGlobalIndex(headingIndex,subheadingIndex,itemIndex)]?.start}}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Service UI -->
    <div class="bg-white-pdf w794" style="page-break-before: always">
        <ng-container *ngFor="let heading of tableofItems; let headingIndex = index">

            <div class="max-w-h banner print-area" style="page-break-before: always;">
                <div class="bg-banner-2 bg-blue d-flex justify-content-center align-items-center">
                    <app-drag>
                        <img class="vector vector-pdf-view 11" style="width: 160px; height: auto;"
                            src="../../../../assets/new-logo/icon-02.svg" alt="loading">
                    </app-drag>
                </div>
            </div>

            <div class="max-w-h banner p-0 print-area" style="page-break-before: always;">
                <div class="bg-banner-2 bg-blue d-flex justify-content-center align-items-center pos-rel-pdf">
                    <app-drag>
                        <h1 class="clr-white text-centyer p-left">{{heading.heading}}</h1>
                    </app-drag>
                    <app-drag>
                        <img class="vector-2" style="opacity: 0.2;" src="../../../../assets/new-logo/icon-02.svg" alt="loading">
                    </app-drag>
                </div>
            </div>

            <div *ngIf="hasText(heading?.description)" class="max-w-h s-bg-img-local-2 print-area my-2" style="page-break-before: always;">
                <div class="p-pdf-bottom">
                    <div class="px-6rem">
                        <div class="d-flex flex-column-reverse gap-2 align-items-baseline">
                            <div class="b-bottom"></div>
                            <img class="pdf-page-logo-left" src="{{fileUrl + heading.heading_icon}}" alt="loading">
                        </div>
                        <div style="color: black;" [innerHTML]="heading?.description"></div>
                    </div>
                </div>
            </div>

            <ng-container *ngFor="let subheading of heading.subheadings; let subheadingIndex = index">
                <div *ngFor="let item of subheading.items; let itemIndex = index" style="page-break-after: always;">
                    <ng-container *ngIf="data[item.item_num] as currentItem">
                        <div id="item-div" class="only-x-6rem mt-2">
                            <!-- header -->
                            <div class="d-flex flex-column-reverse gap-2 align-items-baseline">
                                <div class="b-bottom"></div>
                                <img class="pdf-page-logo-left" src="{{fileUrl + heading.heading_icon}}" alt="loading">
                            </div>

                            <!-- <div *ngIf="getGlobalIndex(headingIndex,subheadingIndex,itemIndex) % 2 === 0" class="header-logo">
                                    <div class="b-bottom"></div>
                                    <div class="">
                                        <img class="header-logo-img" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg"
                                            alt="loading">
                                    </div>
                                </div> -->
                            <!-- header end -->
                            <h1
                                class="{{currentTypeFilter == 'service' ? 'blue-heading-mini' : 'blue-heading-mini-faq'}}">
                                {{item.title}}</h1>
                            <div *ngFor="let field of currentItem?.fields; let i = index">
                                <div class="d-flex align-items-center" style="page-break-after: avoid;">
                                    <i [ngClass]="field.label?.icon + ' font-1_2rem'" class="m-2 blue-heading"></i>
                                    <h3 class="vertical-align-middle blue-heading">
                                        {{field.label?.name}}</h3>
                                </div>

                                <div class="row" style="margin: 0.5rem 1rem;color: black;page-break-before: avoid;">
                                    <div class="col-12">
                                        <div [ngSwitch]="getFieldType(field.label?.type)">
                                            <div *ngSwitchCase="'text'">
                                                <div class="pdf-text line-space mb-0 datacontent" *ngIf="field.data"
                                                    [innerHTML]="(field.data ?? '') | safeHTML">
                                                </div>
                                            </div>
                                            <div *ngSwitchCase="'Rich text'">
                                                <div class="pdf-text line-space mb-0 datacontent" *ngIf="field.data"
                                                    [innerHTML]="(field.data ?? '') | safeHTML">
                                                </div>
                                            </div>
                                            <div *ngSwitchCase="'Upload Image'">
                                                <img [hidden]="field.data == ''" class="img-fluid upload-img"
                                                    [src]="GlobalConstants.staticFilesURL+field.data">
                                            </div>
                                            <div *ngSwitchCase="'Upload Document'">
                                                <a class="doc-view" [hidden]="field.data == ''" target="_blank"
                                                    [href]="GlobalConstants.staticFilesURL+field.data">
                                                    <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{"Add
                                                    file" |
                                                    translator}}
                                                </a>

                                            </div>
                                            <div *ngSwitchCase="'Data Item'" style="padding:20px; margin:20px;">
                                                <p class="color-bold" style="color: #27306F;">
                                                    {{field?.data?.name}}</p>

                                                <div class="my-3"
                                                    *ngFor="let field of sortFiled(field.data.fields); let i = index"
                                                    iconPos="end">

                                                    <div class="d-flex align-items-center"
                                                        style="padding:10px; margin:10px">
                                                        <i [ngClass]="field.label?.icon + ' font-1_2rem'"
                                                            style="color: #27306F;font-weight: 800;" class="m-2"></i>
                                                        <span class="vertical-align-middle font-1_1rem"
                                                            style="color: #27306F;font-weight: 800;">{{field.label?.name}}</span>
                                                    </div>


                                                    <div class="row">
                                                        <div class="col-10">
                                                            <div [ngSwitch]="getFieldType(field.label?.type)">
                                                                <div *ngSwitchCase="'text'">
                                                                    <div class="pdf-text line-space mb-0 datacontent flex-column"
                                                                        *ngIf="field.data"
                                                                        [innerHTML]="(field.data ?? '') | safeHTML">
                                                                    </div>
                                                                </div>
                                                                <div *ngSwitchCase="'Rich text'">
                                                                    <div class="pdf-text line-space mb-0 datacontent flex-column"
                                                                        *ngIf="field.data"
                                                                        [innerHTML]="(field.data ?? '') | safeHTML">
                                                                    </div>
                                                                </div>
                                                                <div *ngSwitchCase="'Upload Image'">
                                                                    <img [hidden]="field.data == ''"
                                                                        class="img-fluid upload-img"
                                                                        [src]="GlobalConstants.staticFilesURL+field.data">
                                                                </div>
                                                                <div *ngSwitchCase="'Upload Document'">
                                                                    <a class="doc-view" [hidden]="field.data == ''"
                                                                        target="_blank"
                                                                        [href]="GlobalConstants.staticFilesURL+field.data">
                                                                        <i [hidden]="field.data == ''"
                                                                            class="pi pi-file mx-2"></i>
                                                                        {{"Add file" | translator}}
                                                                    </a>

                                                                </div>
                                                                <div *ngSwitchCase="'Data Item'">
                                                                </div>
                                                                <div *ngSwitchDefault>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                            <div *ngSwitchDefault></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="page-break-before: avoid;">
                                <qrcode [elementType]="'url'" [qrdata]="getHostname() + '/data/'+item.id"
                                    [errorCorrectionLevel]="'M'"></qrcode>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </ng-container>

    </div>

    <div class="container max-w-h s-bg-img-local-2 print-area" style="page-break-before: always;">
        <div class="px-6rem">
            <app-drag>
                <div *ngIf="tableofItems.length == 1" class="d-flex flex-column-reverse gap-2 align-items-baseline">
                    <div class="b-bottom"></div>
                    <img class="pdf-page-logo-left" src="{{ fileUrl + tableofItems[0].heading_icon }}" alt="loading">
                </div>

                <div class="d-flex flex-column my-5 py-5">
                    <div class="s-g-txt-border">
                        <div class="s-g-text">
                            يمكنكم الاطلاع على الأسئلة الشّائعة الخاصة بخدمات المؤسسة العامة للتأمينات الاجتماعية من
                            خلال الرابط التالي:
                        </div>
                    </div>
                    <div class="s-g-qr">

                        <div
            #qrCodeContainer
            class="p-4 min-h-[220px] min-w-[220px]"
            [innerHTML]="qrSvgContent()"
          >
            <!-- SVG content will be rendered here -->
            @if (!qrSvgContent()) {
              <div class="h-[220px] w-[220px] flex items-center justify-center text-gray-400 text-sm">
                No QR Code Available
              </div>
            }
          </div>

                    </div>
                </div>
            </app-drag>
        </div>
    </div>

    <div class="container max-w-h banner my-2 print-area" style="page-break-before: always;" contenteditable="false">
        <div class="bg-banner">

            <div class="footer-pdf">
                <app-drag contentClass="bottom-100">
                    <div class="print-footer d-flex">
                        <div class="mx-4 b-l" style="pointer-events: none;">
                            <img class="footer-vector" style="pointer-events: none;"
                                src="../../../../assets/new-logo/icon-02.svg" alt="loading">
                        </div>

                        &#8203;
                        <!-- <div class="d-flex align-items-end flex-column mx-4">
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <div contenteditable="true" class="footer-white">199080</div>
                                <i class="mx-2 footer-white fa-brands fa-whatsapp"></i>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="d-flex align-items-center">
                                <div contenteditable="true" class="footer-white">+99611228 2881</div>
                                <i class="mx-2 footer-white fa-solid fa-headphones"></i>
                            </div>
                        </div>
                    </div> -->

                        <div class="d-flex align-items-end flex-column mx-4 mb-2">
                            <div class="d-flex mb-2">
                                <div class="d-flex align-items-center mll-2">
                                    <div contenteditable="true" class="footer-white">199080</div>
                                    <i class="mx-2 footer-white fa-brands fa-whatsapp"></i>
                                </div>
                                <div class="d-flex">
                                    <div class="d-flex align-items-center">
                                        <div contenteditable="true" class="footer-white" dir="ltr">+966 112 822 881
                                        </div>
                                        <i class="mx-2 footer-white fa-solid fa-headphones"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex mb-2">
                                <div class="d-flex align-items-center mll-2">
                                    <div contenteditable="true" class="footer-white">BUSINESS.SA</div>
                                    <i class="mx-2 footer-white fa-solid fa-globe"></i>
                                </div>
                                <div class="d-flex align-items-center">
                                    <div contenteditable="true" class="footer-white">BCGOV_SA</div>
                                    <i class="mx-2 footer-white pi pi-twitter"></i>
                                </div>
                            </div>
                            <div class="d-flex">
                                <div class="d-flex align-items-center">
                                    <div contenteditable="true" class="footer-white-2">SAUDI BUSINESS CENTER</div>
                                    <i class="mx-1 footer-white fa-brands fa-instagram"></i>
                                    <i class="mx-1 footer-white fa-brands fa-linkedin"></i>
                                    <i class="mx-1 footer-white fa-brands fa-youtube"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </app-drag>
            </div>
        </div>
    </div>
</div>
<!-- service pdf end -->

<!-- questions pdf start -->
<div #questions id="questions" class="container-fluid bg-content" *ngIf="!processing && fromQuestions"
    contenteditable="true">
    <div class="container p-0 w-794-question s-bg-img-pdf-2-home">
        <div class="p-pdf-bottom">
            <div class="only-x-6rem">
                <div class="d-flex">
                    <app-drag>
                        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                    </app-drag>
                    <!-- <div class="b-bottom"></div> -->
                </div>
                <div class="d-flex justify-content-center">
                    <div class="s-flex-pdf-2-home">
                        <app-drag>
                            <div class="d-flex flex-column justify-content-center">
                                <h1 style="text-align: center;" class="s-main">دليل المعلومات لخدمات الجهات</h1>
                            </div>
                        </app-drag>
                        <app-drag>
                            <div class="d-flex flex-column justify-content-center">
                                <h6 class="s-semi-tilt">بناك الاختبارات</h6>
                            </div>
                        </app-drag>
                        <app-drag>
                            <div class="d-flex flex-column justify-content-center" style="text-align: center;">
                                <p class="s-p-txt">(موظفي خدمات المستثمرين)</p>
                                <p class="s-p-txt">الإصدار الثاني (النسخة المحتقة)</p>
                            </div>
                        </app-drag>
                    </div>
                </div>
            </div>
            <!-- <div class="s-footer pos-rel-pdf">
                <div class="c-f-img-1">
                    <img class="c-f-img-1-pic" src="../../../../assets/icones-2025/Vector.png" alt="loading">
                </div>
                <div class="c-f-img-2">
                    <img class="c-f-img-2-pic" src="../../../../assets/icones-2025/Group-2.png" alt="loading">
                </div>
                <div class="s-footer-flex">
                    <p class="s-footer-txt-1">سعاده فيما نتحم</p>
                    <p class="s-footer-txt-2">سعادة، ولكن بفضل هؤلاء الأشخاص الذين ل</p>
                </div>
            </div> -->
            <div class="s-footer-pdf-2 pos-rel-pdf">
                <!-- <div class="c-f-img-1">
                    <img class="c-f-img-1-pic" src="../../../../assets/icones-2025/Vector.png" alt="loading">
                </div>
                <div class="c-f-img-2-pdf-2">
                    <img class="c-f-img-2-pic-pdf-2" src="../../../../assets/icones-2025/Group-2.png" alt="loading">
                </div> -->
                <div class="s-footer-flex">
                    <app-drag>
                        <p class="s-footer-txt-1-home-question">{{formattedArabicDate}}</p>
                    </app-drag>
                    <app-drag>
                        <p class="s-footer-txt-2-pdf-2-home-question">الإدارة العامة للشراكات
                            وتطوير القدرات</p>
                    </app-drag>
                </div>
            </div>

        </div>
    </div>

    <div class="container p-0 w-794-question bg-white-pdf" style="page-break-before: always;">
        <div class="p-pdf-bottom">
            <div class="only-x-6rem">
                <div class="d-flex">
                    <app-drag>
                        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                    </app-drag>
                    <!-- <div class="b-bottom"></div> -->
                </div>
                <div class="w-100 d-center">
                    <div class="s-flex-pdf-2-question">
                        <app-drag>
                            <div class="d-flex flex-column justify-content-center">
                                <h1 style="text-align: center;" class="s-main">دليل المعلومات لخدمات الجهات</h1>
                            </div>
                        </app-drag>
                        <app-drag>
                            <div class="d-flex flex-column justify-content-center" style="text-align: center;">
                                <p class="s-p-txt">(موظفي خدمات المستثمرين)</p>
                                <p class="s-p-txt">الإصدار الثاني (النسخة المحتقة)</p>
                            </div>
                        </app-drag>
                        <app-drag>
                            <div class="d-flex flex-column justify-content-center">
                                <h6 class="s-semi">{{formattedArabicDate}}</h6>
                            </div>
                        </app-drag>
                    </div>
                </div>
            </div>
            <div class="s-footer pos-rel-pdf">
                <div class="c-f-img-1">
                    <app-drag>
                        <img class="c-f-img-1-pic" src="../../../../assets/icones-2025/Vector.png" alt="loading">
                    </app-drag>
                </div>
                <div class="s-footer-flex">
                    <app-drag>
                        <p class="s-footer-txt-2-pdf-2">الإدارة العامة للشراكات
                            وتطوير القدرات</p>
                    </app-drag>
                </div>
            </div>
        </div>
    </div>

    <div class="container w-794-question-pdf-2 banner" style="page-break-before: always;">
        <div class="bg-banner-service">
            <div class="d-flex flex-column">
                <!-- <img class="w-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading"> -->
                <div class="p-3rem">

                    <div class="d-flex flex-column">
                        <h4 class="my-5-pdf-2">مقدمة: </h4>
                        <p class="pdf-text-white">
                            انطلاقاً من توجه المركز السعودي للتنافسية والأعمال في بناء القدرات المعرفية لمنسوبيه ورفع جودة الخدمات
                            المقدمة للمستثمرين في المركز، فقد تم العمل على بناء دليل المعلومات لخدمات الجهات بهدف تعزيز
                            البناء المعرفي لدى موظفي خدمات المستثمرين وقطاع الأعمال، كما سيكون مصدرًا للاختبارات الشاملة
                            التي ستنعقد بشكل دوري خلال العام بهدف قياس أداء الموظف ومعرفة المكامن القابلة للتحسين وفقًا
                            للنتائج والمخرجات، والعمل عليها وتطويرها حتى يتمكن الموظف من تطبيق أفضل الممارسات في مجال
                            خدمة المستثمرين وتحرّي الدقة أثناء تقديم الخدمة.
                            <br /><br />
                            بُنيَ الدليل من خلال مجموعة من المستشارين في الجهات الحكومية وتم تحكيم الأسئلة وإجاباتها
                            لضمان أعلى موثوقية، ويتكون الدليل من 9 أجزاء، كل جزء معنون باسم الجهة الحكومية ويحتوي على
                            مجموعة من الأسئلة وإجاباتها في مجال الخدمات التي تقدم في المركز.
                            <br /><br />
                            كما يتضمن كل جزء مجموعة من نماذج الأسئلة التي سيتم على غرارها بناء الاختبار الشامل للموظفين،
                            وينتهي كل جزء بمجموعة من المصادر التي من المهم اطلاع الموظفين عليها لإثراء معلوماتهم.
                            <br /><br />
                            الدليل هو بنك من المعلومات والتي سيتم إن شاء الله تحديثها وفق المستجدات في الأنظمة
                            والسياسيات لدى الجهات الحكومية وبالتالي سيتم عكس ذلك على الأسئلة وأنواعها وأنماطها، مؤملين
                            اطلاع الموظفين على المعلومات لكل جهة حكومية وقياس مدى معرفة كل موظف من خلال التقييم الذاتي
                            للمعلومات المتوفرة.
                            <br /><br />
                            شاكرين جهود فريق العمل الذي شارك في بناء ومراجعة وتصميم الدليل وعمل دؤوب والحرص على تحري
                            الدقة والموضوعية.

                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="question-index-page" class="container w-794-question s-bg-img-local" style="page-break-before: always;">
        <div class="only-x-6rem">

            <app-drag>
                <div class="d-flex">
                    <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                </div>
            </app-drag>
            <!-- <div class="b-bottom"></div> -->

            <div>
                <h4 class="head-purply my-5 print-p-top-question"> المحتويات :</h4>
                <div class="d-flex align-items-center" *ngFor="let question of printableQuestions;let i = index">
                    <div>
                        <div class="dot-purply"></div>
                    </div>
                    <div class="txt-width">
                        <p class="txt-purply">{{question.ministry.label}}</p>
                    </div>
                    <div class="dots-purply"></div>
                    <p class="txt-purply">{{indexData[i]?.start}}</p>
                </div>
            </div>
        </div>
    </div>

    <div class="container p-0 s-bg-img-copy w-794-question-pdf-2" style="page-break-before: always;">
        <div class="p-pdf-bottom">
            <div class="only-px-6rem-pdf-2">
                <app-drag>
                    <div class="d-flex">
                        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                    </div>
                </app-drag>
                <h4 class="head-purply my-5 print-p-top-question"> كيف تقرأ الدليل :</h4>
            </div>
            <div class="section-padding">
                <!-- Stats Section -->
                <div class="d-flex align-items-center">
                    <div class="bg-head-box-1-pdf-2">مكونات الدليل</div>
                    <div class="stats">
                        <div class="pos-rel-pdf">
                            <div class="pos-abs-circle-triangle-1-pdf-2"></div>
                            <div class="stat-box-1-pdf-2">
                                <div class="icon-1-pdf-2">
                                    <div class="pos-abs-services"><i class="fa-solid fa-building"></i></div>
                                </div>
                                <div class="number-1-pdf-2">{{sampleCount}}</div>
                                <div class="desc-1-pdf-2">جهات وبرامج حكومية</div>
                            </div>
                        </div>
                        <div class="pos-rel-pdf">
                            <div class="pos-abs-circle-triangle-2-pdf-2"></div>
                            <div class="stat-box-2-pdf-2">
                                <div class="icon-2-pdf-2">
                                    <div class="pos-abs-services"><i class="fa-solid fa-lightbulb"></i></div>
                                </div>
                                <div class="number-2-pdf-2">{{printableQuestionCount}}</div>
                                <div class="desc-2-pdf-2">إجمالي عدد الأسئلة مع إجاباتها</div>
                            </div>
                        </div>
                        <div class="pos-rel-pdf">
                            <div class="pos-abs-circle-triangle-3-pdf-2"></div>
                            <div class="stat-box-3-pdf-2">
                                <div class="icon-3-pdf-2">
                                    <div class="pos-abs-services"><i class="fa-solid fa-sliders"></i></div>
                                </div>
                                <div class="number-3-pdf-2">{{printableQuestions.length}}</div>
                                <div class="desc-3-pdf-2">إجمالي عدد نماذج الاختبارات</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Stats Section -->


                <!-- Stats Section -->
                <div class="d-flex align-items-center">
                    <div class="bg-head-box-2-pdf-2">معلومات أقسام الدليل</div>
                    <div class="d-flex align-items-start flex-column justify-content-start gap-3">
                        <span class="h4-ui-2">يتضمن الدليل في كل جزء من أجزائه ثلاثة معلومات أساسية:</span>
                        <div class="box-flex">
                            <div class="pos-rel-pdf">
                                <div class="rate-box-rating">1</div>
                                <div class="rate-box-rating-num-pdf-2">1</div>
                                <div class="rate-box-pdf-2">مقدمة عن الجهة</div>
                            </div>
                            <div class="pos-rel-pdf">
                                <div class="rate-box-rating">2</div>
                                <div class="rate-box-rating-num-pdf-2">2</div>
                                <div class="rate-box-pdf-2">أسئلة عامة مع إجاباتها</div>
                            </div>
                            <div class="pos-rel-pdf">
                                <div class="rate-box-rating">3</div>
                                <div class="rate-box-rating-num-pdf-2">3</div>
                                <div class="rate-box-pdf-2">3 أسئلة لنموذج الاختبار</div>
                            </div>
                            <div class="pos-rel-pdf">
                                <div class="rate-box-rating">4</div>
                                <div class="rate-box-rating-num-pdf-2">4</div>
                                <div class="rate-box-pdf-2">مصادر اللطاع</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Stats Section -->

                <!-- Stats Section -->
                <div class="d-flex align-items-center">
                    <div class="bg-head-box-3-pdf-2">آلية التقديم على الاختبار *</div>

                    <div class="d-flex">
                        <div class="pos-rel-pdf">
                            <div class="pos-text-adj">
                                <div class="d-flex align-items-center">
                                    <h4 class="h4-ui">كيف يتم التقديم على
                                        الاختبار والحصول على النتائج</h4>
                                    <i class="fa-solid-icone fa-solid fa-question"></i>
                                </div>
                            </div>
                            <div class="pos-text-adj-2">
                                <div class="d-flex flex-column">
                                    <div class="d-flex align-items-baseline">
                                        <h5 class="h5-ui">1</h5>
                                        <div class="underline"></div>
                                    </div>
                                    <p class="under-text">الاطلاع على دليل
                                        المعلومات لخدمات
                                        الجهات ودراسة
                                        الأسئلة مع إجاباتها</p>
                                </div>
                            </div>
                        </div>

                        <div class="px-130 d-flex pos-rel-pdf">

                            <div class="pos-rel-pdf">
                                <div class="c-box-border-1">
                                    <i class="pos-abs-service-arrow-1 fa-solid fa-caret-up"></i>
                                    <div class="c-box-1">
                                        <i class="fa-solid fa-book-open"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="pos-rel-pdf">
                                <div class="c-box-border-2">
                                    <div class="c-box-2">
                                        <i class="pos-abs-service-arrow-2 fa-solid fa-caret-up"></i>
                                        <i class="fa-solid fa-desktop"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="pos-rel-pdf">
                                <div class="c-box-border-3">
                                    <div class="c-box-3">
                                        <i class="fa-brands fa-searchengin"></i>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="pos-rel-pdf">
                            <div class="pos-text-adj-3">
                                <div class="d-flex flex-column">
                                    <div class="d-flex align-items-baseline">
                                        <h5 class="h5-ui">2</h5>
                                        <div class="underline"></div>
                                    </div>
                                    <p class="under-text">التقديم على الاختبار والذي
                                        سيتاح كل ثلاثة أشهر
                                        (الدخول إلزامي)</p>
                                </div>
                            </div>
                            <div class="pos-text-adj-4">
                                <div class="d-flex flex-column">
                                    <div class="d-flex align-items-baseline">
                                        <h5 class="h5-ui">3</h5>
                                        <div class="underline"></div>
                                    </div>
                                    <p class="under-text">استخراج النتائج ومراجعتها، في حال الاجتياز تُرسل النتائج إلى
                                        إدارة الموارد البشرية لتضمينها في ملف إنجازات الموظف، وفي حال عدم الاجتياز يتم
                                        إعادة الاختبار مرة واحدة فقط.</p>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
                <!-- Stats Section -->



            </div>
            <div class="container-fluid fifth-pg-bg p-0">
                <div class="d-flex justify-content-between">
                    <div class="">
                        <p class="fifth-pg-img-text">* علماً بأنه سيتم إرسال إجراءات الاختبار بوقت لا يقل عن شهر من
                            تاريخ بدء الاختبار</p>
                    </div>
                    <div class="pos-rel-pdf">
                        <img class="fifth-pg-img" src="../../../../assets/icones-2025/Group-2.png" alt="loading">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Questions view -->
    <ng-container *ngFor="let question of printableQuestions;let i = index">
        <div class="container p-0 w-794-question s-bg-img-2" style="page-break-before: always;">
            <div class="p-pdf-bottom">
                <div class="only-x-6rem">
                    <app-drag>
                        <div class="d-flex">
                            <img class="w-logo-pdf-2 print-p-top-logo-question"
                                src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                        </div>
                    </app-drag>
                    <div class="d-flex justify-content-start">
                        <div class="s-flex-2-pdf-2">
                            <app-drag>
                                <img class="filtered-logo-pdf-2" [src]="fileUrl + question.ministry.icon" alt="loading">
                            </app-drag>
                            <app-drag>
                                <div class="filtered-txt">
                                    <h1>{{i + 1}}</h1>
                                    <h4>{{question.ministry.label}}</h4>
                                </div>
                            </app-drag>
                        </div>
                    </div>
                </div>
                <div class="my-5 pos-rel-pdf">
                    <div class="c-f-img-4-question">
                        <app-drag>
                            <div class="s-box-sticky">
                                <div class="d-flex flex-column">
                                    <h1 class="s-box-sticky-num">{{question.count}}</h1>
                                    <p class="s-box-sticky-txt">سؤال</p>
                                </div>
                            </div>
                        </app-drag>
                    </div>
                    <app-drag>
                        <div class="c-f-img-3-pdf-2">
                            <img class="c-f-img-3-pdf-2-picture" src="../../../../assets/icones-2025/Group-2.png"
                                alt="loading">
                        </div>
                    </app-drag>
                </div>
            </div>
        </div>

        <div class="container w-794-question s-bg-img-local" style="page-break-before: always;">
            <div class="p-pdf-bottom">
                <div class="only-x-6rem">
                    <app-drag>
                        <div class="d-flex">
                            <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                            <!-- <div class="b-bottom"></div> -->
                        </div>
                    </app-drag>
                    <div>
                        <app-drag>
                            <h6 class="head-one my-5 text-center print-p-top-question">{{question.ministry.label}}</h6>
                        </app-drag>
                        <h6 class="head-two my-3">ةمدقم</h6>
                        <p class="pdf-description" [innerHTML]="question.ministry.description">
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div id="question-content" class="container s-bg-img-local-no-h-question w-794-question-pdf-2"
            style="page-break-before: always;">
            <div class="only-x-6rem d-flex flex-column gap-2">
                <div class="d-flex">
                    <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                </div>
                <div>
                    <div class="head-three d-flex flex-column print-p-top-question"
                        *ngFor="let data of question.data;let dataIndex = index">
                        <div class="d-flex my-3" style="page-break-after: avoid;">
                            <div class="head-three">&nbsp;&nbsp;&nbsp;{{dataIndex + 1}}-&nbsp;&nbsp;&nbsp;</div>
                            {{data.name}}
                        </div>
                        <pre class="pdf-text m-custom"
                            style="all: revert-layer;page-break-before: avoid;white-space: pre-wrap;font-family: 'DINNextLTArabic';"
                            [innerHTML]="(data.description ?? '') | safeHTML"></pre>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!!question.sample && question.sample.length > 0" class="container w-794-question s-bg-img-semi"
            style="page-break-before: always;">
            <div class="p-pdf-bottom">
                <div class="only-x-6rem">
                    <div class="d-flex">
                        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                        <!-- <div class="b-bottom"></div> -->
                    </div>
                    <div class="sample-box">
                        <div class="question-template-box-ui print-p-top-logo-question"
                            *ngFor="let sample of question.sample;let si = index" style="color: black;">
                            <app-question-template [showCorrect]="true" [isAssessment]="true" [disabled]="true"
                                [question]="sample"></app-question-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container w-794-question s-bg-img-lcd" style="page-break-before: always;">
            <div class="p-pdf-bottom">
                <div class="only-x-6rem">
                    <div class="d-flex">
                        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                        <!-- <div class="b-bottom"></div> -->
                    </div>
                    <div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>
<!-- questions pdf end -->

<div class="d-center" *ngIf="processing" style="height: 100vh; width: 100%;">
    <p-progressSpinner strokeWidth="2"></p-progressSpinner>
</div>


<button class="float" (click)="print()" *ngIf="!processing && indexesCalculated">
    <span class="pi pi-print"></span>
</button>

<button id="print-service" styleSheetFile="./pdf-builder.component.scss"
    [printStyle]="{'#print-data':{'display':'block'},'*':{'direction': 'rtl'},'html':{'direction': 'rtl','background':'#fff !important','color-scheme':'light !important'},'body':{'direction': 'rtl','background':'#fff !important','margin':'0 !important','padding':'0 !important'},'body .container.print-area.banner.my-2':{'margin-top':'0 !important','margin-bottom':'0 !important','width':'210mm !important','max-width':'210mm !important','height':'297mm !important','min-height':'297mm !important','max-height':'297mm !important','margin-left':'0 !important','margin-right':'0 !important','padding':'0 !important','overflow':'hidden !important'},'body .container.s-bg-img-local-2.print-area.my-2':{'margin-top':'0 !important','margin-bottom':'0 !important','width':'210mm !important','max-width':'210mm !important','height':'297mm !important','min-height':'297mm !important','max-height':'297mm !important','margin-left':'0 !important','margin-right':'0 !important','padding':'0 !important','overflow':'hidden !important'},'body > .s-bg-img-1':{'min-height':'0 !important','height':'297mm !important','max-height':'297mm !important','width':'210mm !important','max-width':'210mm !important','overflow':'hidden !important','margin':'0 !important'}, 'p img': {'width': 'auto !important'}  }"
    printSectionId="print-data" ngxPrint [useExistingCss]="true" style="display: none;">
</button>


<button id="print-question"
    [printStyle]="{'#questions':{'display':'block'},'*':{'direction': 'rtl'},'html':{'direction': 'rtl'},'body':{'direction': 'rtl'} }"
    printSectionId="questions" ngxPrint [useExistingCss]="true" style="display: none;">
</button>